import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { AssignProjectToAPIKeyRPC } from "./assignProjectToApiKeyRPC";

export class AssignProjectToAPIKeyRPCClientImpl extends AssignProjectToAPIKeyRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: AssignProjectToAPIKeyRPC.Request): Promise<LeoRPCResult<AssignProjectToAPIKeyRPC.Response, AssignProjectToAPIKeyRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "external-public-apis/AssignProjectToAPIKey",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      AssignProjectToAPIKeyRPC.ResponseDTO,
      AssignProjectToAPIKeyRPC.Errors.ErrorsDTO,
      AssignProjectToAPIKeyRPC.Response,
      AssignProjectToAPIKeyRPC.Errors.Errors
    >(
      response,
      "external-public-apis/AssignProjectToAPIKey",
      AssignProjectToAPIKeyRPC.Response.fromDTO,
      AssignProjectToAPIKeyRPC.Errors.fromDTO
    );
  }
}
